const apiUrl = process.env.REACT_APP_API_URL;

// src/api/auth.ts
export const login = async (username: string, password: string) => {
  const response = await fetch(apiUrl + '/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error('Login failed');
  }

  return response.json();
};